import { clamp } from '../../../utils/clamp.es.js';

var steps = function steps(_steps) {
  var direction = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "end";
  return function (progress) {
    progress = direction === "end" ? Math.min(progress, 0.999) : Math.max(progress, 0.001);
    var expanded = progress * _steps;
    var rounded = direction === "end" ? Math.floor(expanded) : Math.ceil(expanded);
    return clamp(0, 1, rounded / _steps);
  };
};

export { steps };